import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	timeStamp: null,

	loading: false,
	createBookingLoading: false,
	updateBookingLoading: false,
	deleteBookingLoading: false,
	bookingsLoadingComplete: false,

	error: null,
	searchable: true
};

const bookingSlice = createSlice({
	name: 'bookings',
	initialState,
	reducers: {
		// 🔥 Load Bookings
		loadBookings: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadBookingsSuccess: (state, action) => {
			state.timeStamp = Date.now();
			state.loading = false;

			const orgID = action.payload.orgID;
			const oldBookingsData = state.data[orgID] || [];

			// Merge bookings data using 'bookingID' as the unique identifier
			state.data[orgID] = mergeReduxStateData(oldBookingsData, action.payload.data, 'bookingID');

			state.bookingsLoadingComplete = true;
		},
		loadBookingsError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},

		// 🔥 Create Booking
		createBooking: (state) => {
			state.createBookingLoading = true;
			state.error = null;
		},
		createBookingSuccess: (state) => {
			state.createBookingLoading = false;
		},
		createBookingError: (state, action) => {
			state.createBookingLoading = false;
			state.error = action.payload;
		},

		// 🔥 Update Booking
		updateBooking: (state) => {
			state.updateBookingLoading = true;
			state.updateBookingComplete = false; // 🔄 resetea
			state.error = null;
		},
		updateBookingSuccess: (state) => {
			state.updateBookingLoading = false;
			state.updateBookingComplete = true; // ✅ señal de éxito
		},
		updateBookingError: (state, action) => {
			state.updateBookingLoading = false;
			state.updateBookingComplete = false;
			state.error = action.payload;
		},
		resetUpdateBookingState: (state) => {
			state.updateBookingComplete = false;
			state.updateBookingLoading = false;
			state.error = null;
		},

		// 🔥 Delete Booking
		deleteBooking: (state) => {
			state.deleteBookingLoading = true;
			state.error = null;
		},
		deleteBookingSuccess: (state) => {
			state.deleteBookingLoading = false;
			state.deleteBookingComplete = true;
		},
		deleteBookingError: (state, action) => {
			state.deleteBookingLoading = false;
			state.error = action.payload;
		},
		clearDeleteBookingState: (state) => {
			state.deleteBookingComplete = false;
			state.error = null;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => {
			return initialState; // Reset state on logout
		});
	}
});

// Export the actions
export const bookingActions = bookingSlice.actions;

// Export the reducer
export default bookingSlice.reducer;
